import { isProd } from 'v2/configs/constants'
import { type ModulePermissionTypeMap, RbacModules, RbacPermissionTypes } from 'v2/types/rbac'

export interface TtsPermissions {
  canView: boolean
  canCreate: boolean
  canEdit: boolean
  canDelete: boolean
}

// ponytail: hodor's `config/rbacConstants.go` has no ModuleTts rows yet, so the evaluated map
// carries no `tts` entry at all and every grant reads false — which would hide the module from
// the people building it. Outside prod, an ABSENT module means "catalogue not shipped yet" and
// resolves to all-true; a module that IS present is always read verbatim, so the day hodor ships
// the rows this fallback stops applying on its own. Delete the parameter then.
export const allowMissingTtsModule = !isProd

/**
 * Pure so the matrix is testable without a permissions harness (failure mode 17), and so the
 * route config and the hook cannot spell the gate differently (failure mode 18).
 */
export const resolveTtsPermissions = (
  permissionsMap: ModulePermissionTypeMap | undefined,
  allowMissingModule = allowMissingTtsModule,
): TtsPermissions => {
  const modulePermissions = permissionsMap?.[RbacModules.tts]

  if (!modulePermissions && allowMissingModule) {
    return { canView: true, canCreate: true, canEdit: true, canDelete: true }
  }

  return {
    canView: modulePermissions?.[RbacPermissionTypes.view] ?? false,
    canCreate: modulePermissions?.[RbacPermissionTypes.create] ?? false,
    canEdit: modulePermissions?.[RbacPermissionTypes.edit] ?? false,
    canDelete: modulePermissions?.[RbacPermissionTypes.delete] ?? false,
  }
}
